import { Col, Row, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ErrorMessage } from "@hookform/error-message";
import FormItem from "../../form-item";
import {Controller} from "react-hook-form";
import {MediumFor} from "../../../../models/medium/enum";
import FileUploader from "../../../form-components/file-uploader";

interface IProps {

}

const ImportExcel: React.FC<IProps> = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <Row gutter={[16, 8]}>
        <Col span={24}>
          <FormItem label={t("file")}>
            <Controller
              name="fileId"
              rules={{
                required: {
                  value: false,
                  message: `${t("field_is_required_message")}`,
                },
              }}
              render={({ field: { ref, ...field } }) => {
                return (
                  <FileUploader
                    {...field}
                    type="DRAGGER"
                    onChange={(response) => {
                      field.onChange(response?.id);
                    }}
                    fileFor={MediumFor.PRODUCT_EXCEL}
                  />
                );
              }}
            />
          </FormItem>
        </Col>
      </Row>
    </>
  );
};

export default ImportExcel;
